export default __webpack_public_path__ + "static/media/background1.4d8a5365.jpg";